import React from "react";
import classNames from "classnames";
import "./Elements.scss";
import { withDefaults } from "../../utils/withDefaults";

export const headerSizes = {
  LARGE: "h1",
  MEDIUM: "h2",
  SMALL: "h3",
  EXTRA_SMALL: "h4"
} as const;

export type HeaderSize = (typeof headerSizes)[keyof typeof headerSizes];

export interface HProps {
  size?: HeaderSize;
  className?: string;
  textAlign?: React.CSSProperties["textAlign"];
  usePermanentAccent?: boolean;
  children?: React.ReactNode;
}

export default function H(incomingProps: HProps) {
  const props = withDefaults(incomingProps, hDefaultProps);

  const Element = props.size;

  return (
    <Element
      className={classNames(
        props.className,
        props.usePermanentAccent ? "permanent" : ""
      )}
      style={{ textAlign: props.textAlign }}
    >
      {props.children}
    </Element>
  );
}

const hDefaultProps = {
  size: headerSizes.LARGE,
  className: "",
  textAlign: "left" as React.CSSProperties["textAlign"],
  usePermanentAccent: true
};
